<div class="status-migration-dialog">
    <mat-dialog-content>
        <div class="dialog-header">
            <div class="header-content">
                <i class="icon icon-warning error"></i>
                <span class="title-text">{{ 'request_v2.status_migration.title' | translate }}</span>
            </div>
            <div class="close-btn" >
                <mat-icon (click)="close()">close</mat-icon>
            </div>
        </div>
        <div class="dialog-description">
            <span class="description-text" [innerHTML]="'request_v2.status_migration.description' | translate"></span>
        </div>

        <div class="status-selector-section">
            <app-form-select-v2
                #statusSelect
                *ngIf="!isLoading"
                [label]="'request_v2.status_migration.select_status' | translate"
                [placeholder]="'request_v2.status_migration.select_placeholder' | translate"
                [options]="availableStatuses"
                (changeOutput)="onSelectChange($event)"
            >
            </app-form-select-v2>
            <div *ngIf="isLoading" class="loading-spinner">
                <mat-spinner diameter="30"></mat-spinner>
            </div>
        </div>
    </mat-dialog-content>

    <div class="dialog-actions">
        <button class="bciti-button no-transition bciti-button--secondary" (click)="close()">
            {{ 'common.cancel' | translate }}
        </button>
        <button class="bciti-button no-transition bciti-button--dark" (click)="save()">
            <span *ngIf="!isSaving">{{ 'common.save' | translate }}</span>
            <span *ngIf="isSaving" class="button-spinner">
                <mat-spinner diameter="20" color="accent"></mat-spinner>
            </span>
        </button>
    </div>
</div>
